/**
 * Select the first item when user presses Enter in the autocomplete input field
 */
function handleFirstItemAutoSelection(inputfield) {
  let isNavigating = false

  inputfield.addEventListener("keydown", function (e) {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      isNavigating = true
    } else if (e.key === "Enter" || e.keyCode === 13) {
      if (!isNavigating) {
        const event = new KeyboardEvent("keydown", {
          key: "ArrowDown",
          keyCode: 40,
          code: "ArrowDown",
          which: 40,
          bubbles: true
        })
        inputfield.dispatchEvent(event)
      }
    } else if (e.key.length === 1 || e.key === "Backspace" || e.key === "Delete") {
      isNavigating = false
    }
  })
}

function initGooglePlacesAutocomplete(inputfield, callback) {
  if (!window.google) {
    setTimeout(initGooglePlacesAutocomplete.bind(this, inputfield, callback), 1000)
    return false
  }

  const places = new window.google.maps.places.Autocomplete(inputfield)
  window.google.maps.event.addListener(places, "place_changed", callback.bind(null, places))

  handleFirstItemAutoSelection(inputfield)

  return true
}

export default initGooglePlacesAutocomplete
